// extracted by mini-css-extract-plugin
module.exports = {"root":"_f422619","image":"_73f2441","state":"_aee86c6","footer":"_c99e6b7"};